import type { EntityState } from '@reduxjs/toolkit';
import type * as idb from 'idb';
import type { Hour } from 'types/hour';
import type { Suggestion } from 'types/suggestion';
import type { SuggestedEntry, SyntheticEntry } from 'types/timeline';

export const sliceName = 'synthetic';

export const localStorageInjectKey = '__TIMELY_DEV__injectSyntheticMemories';

export interface SyntheticState {
  groups: EntityState<SuggestedEntry, SuggestedEntry['ref']>;
  memories: EntityState<SyntheticEntry, SyntheticEntry['id']>;
  suggestions: EntityState<Suggestion<number>, Suggestion<number>['id']>;
  preservedEntryIds: Record<number, Array<number>>;
  preservedSuggestionEntryIds: Record<number, Array<number>>;
}

export type StoredSuggestion = Pick<Suggestion<number>, 'id' | 'suggested_entry_ids'> &
  Partial<Omit<Suggestion<number>, 'id' | 'suggested_entry_ids'>>;

export interface SyntheticDb extends idb.DBSchema {
  hours: {
    key: number;
    value: Pick<Hour<any>, 'id' | 'entry_ids'>;
  };

  memories: {
    key: number;
    value: SyntheticEntry;
  };

  suggestions: {
    key: number;
    value: StoredSuggestion;
  };
}
